import React from "react";

import { Stack, Typography } from "@mui/material";
import { IBookmark } from "store/types";

import { ViewRow } from "./ViewRow";

interface Props {
  label: string;
  isCurrent: boolean;
  bookmarks: IBookmark[];
  onApplied: () => void;
}

export const PageGroup: React.FC<Props> = ({ label, isCurrent, bookmarks, onApplied }) => (
  <Stack
    sx={{
      padding: "8px 0",
      "& + &": { borderTop: "1px solid #dbe8f5" }
    }}
  >
    <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ padding: "8px 16px" }}>
      <Typography
        sx={{
          fontSize: "11px",
          fontWeight: 700,
          color: "#5e7a95",
          letterSpacing: "0.04em",
          textTransform: "uppercase"
        }}
      >
        {label}
      </Typography>
      {isCurrent ? (
        <Typography
          sx={{
            fontSize: "10px",
            fontWeight: 500,
            color: "#071f35",
            backgroundColor: "#dbe8f5",
            padding: "2px 8px",
            borderRadius: "128px"
          }}
        >
          on this page
        </Typography>
      ) : (
        <Typography sx={{ fontSize: "12px", color: "#92a7bc" }}>{bookmarks.length}</Typography>
      )}
    </Stack>
    {bookmarks.map((bookmark) => (
      <ViewRow key={bookmark.id} bookmark={bookmark} pageLabel={label} onApplied={onApplied} />
    ))}
  </Stack>
);
